export const ROOT_MARGIN_IN_VIEW: string = '3000px';
export const EMAIL = 'mc@studiothework.com';
